export type PrizmCounterStatus = 'info' | 'secondary' | 'success' | 'warning' | 'danger';

export type PrizmCounterPosition = 'tr' | 'tl' | 'br' | 'bl';
